import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * Visual style of StepIndicatorStepValue
   * Available options: "standard", "error"
   */ skin: PropTypes.oneOf([
        'standard',
        'error'
    ])
};
/**
 * @subcomponent StepIndicator
 */ const StepIndicatorStepValue = createComponent({
    displayName: 'StepIndicatorStepValue',
    root: 'span',
    propTypes,
    propConfig: {
        classNames (props) {
            const classNameSet = new Set([
                'swan-step-value'
            ]);
            const { skin = 'standard' } = props;
            if (skin != 'standard') classNameSet.add(`swan-step-value-skin-${skin}`);
            return classNameSet;
        }
    }
});
StepIndicatorStepValue.defaultProps = {
    skin: 'standard'
};

export { StepIndicatorStepValue };
